<prv-tela-principal 
  [exibirBarraTitulo]="false" 
  [exibirApenasModulo]="true" 
  [exibeBotaoVoltar]="false"
  descricaoFuncionalidade="Intranet Corporativa">

  <div class="area__cabecalho__telaPrincipal">
    
    <div class="iframe-container">
      <iframe 
        [src]="urlSegura" 
        class="iframe-full"
        title="Intranet Previmil"
        frameborder="0" 
        allowfullscreen>
      </iframe>
    </div>

  </div>

</prv-tela-principal>